$(function () {
    var items = $('.hindle-shop-widget.-categories .cat-item');
    var lists = items.find('.children');
    var open = 'open';
    var close = 'close';
    var prefix = '-';
    var openClassName = prefix + open;
    var closeClassName = prefix + close;

    if (items.length === 0) {
        return;
    }

    items.each(function (index, element) {
        var item = $(element);
        var list = item.children('.children');

        // No children? Nothing to toggle. Icon = span.
        if (list.length === 0) {
            return item.prepend('<span class="icon">');
        }

        var icon = $('<a href="#" class="icon">');
        var text = $('<span class="screen-reader-text">' + open + '</span>');

        icon.on('click', function (e) {
            e.preventDefault();

            // Toggle visibility, then swap classes and text content
            list.slideToggle().promise().done(function () {
                if (list.is(':visible')) {
                    text.text(close);
                    icon.addClass(closeClassName);
                    icon.removeClass(openClassName);

                    return;
                }

                text.text(open);
                icon.addClass(openClassName);
                icon.removeClass(closeClassName);
            });
        });

        icon.addClass(openClassName);
        icon.prepend(text);
        item.prepend(icon);
        list.hide();
    });
});
